export function isDictionaryLoaded(dictionary, locale) {
    const loadedDictionaries = window.dictionaries;
    
    if(loadedDictionaries === undefined) return false;
    
    return loadedDictionaries.has(`${dictionary}-${locale}`);
}

export function markDictionaryLoaded(dictionary, locale) {
    const loadedDictionaries = window.dictionaries || new Set();

    loadedDictionaries.add(`${dictionary}-${locale}`);
    window.dictionaries = loadedDictionaries;
}